module.exports = __webpack_public_path__ + "static/media/snake.f35a2c39.gif";